import { ROUTES } from './routes';

/**
 * Logged-in app footer (MYN-253). Separate from the public marketing footer
 * (`Footer.tsx`, MYN-220), which links to public pages a signed-in member has
 * no use for.
 */

/**
 * Platform contact address, the same one the Backend uses as every event's
 * default organiser email. Phone and LinkedIn are added when the client
 * supplies them.
 */
export const SUPPORT_EMAIL = 'info@mynextraise.com';

export const APP_FOOTER_STRINGS = {
  TAGLINE: 'Helping founders raise with confidence.',
  QUICK_LINKS_HEADING: 'Quick Links',
  SUPPORT_HEADING: 'Support',
  SUPPORT_TEXT: 'Questions about your account or the platform? Our team is here to help.',
  EMAIL_SUPPORT: 'Email Support',
  TERMS: 'Terms & Conditions',
  RIGHTS_RESERVED: 'All rights reserved.',
  LOGO_LINK_LABEL: (brand: string) => `${brand} dashboard`,
} as const;

/** Internal pages every logged-in persona can open, split into two columns. */
export const APP_FOOTER_LINK_COLUMNS: readonly (readonly { label: string; to: string }[])[] = [
  [
    { label: 'Dashboard', to: ROUTES.DASHBOARD },
    { label: 'Events', to: ROUTES.EVENTS },
    { label: 'Resources', to: ROUTES.RESOURCES },
  ],
  [
    { label: 'Trusted Partners', to: ROUTES.TRUSTED_PARTNERS },
    { label: 'Startup Perks', to: ROUTES.TRUSTED_PARTNERS_PERKS },
    { label: 'My Profile', to: ROUTES.ACCOUNT },
  ],
];
